import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { withIntent } from '../../util/hoc/withIntent.js';
import { Box } from '../Box/Box.js';
import { TimelineContextProvider } from './context/TimelineContext.js';

var _excluded = ["direction", "children"];
var ListContainer = Box;
var TimelineContainer = function TimelineContainer(props) {
  var direction = props.direction,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(TimelineContextProvider, {
    value: {
      direction: direction
    }
  }, /*#__PURE__*/React.createElement(ListContainer, _extends({
    as: "ul",
    display: "flex",
    flexDirection: direction === 'horizontal' ? 'row' : 'column',
    width: direction === 'horizontal' ? '100%' : undefined,
    m: "0",
    p: "0"
  }, rest), children));
};
var ThemableTimelineContainer = withIntent(TimelineContainer);
var TimelineContainerMemoized = /*#__PURE__*/React.memo(ThemableTimelineContainer);
TimelineContainerMemoized.displayName = 'TimelineContainer';

export { TimelineContainerMemoized as BaseTimelineContainer, TimelineContainerMemoized as TimelineContainer };
//# sourceMappingURL=TimelineContainer.js.map
